import React from 'react'
import { Conditional, ShowIf } from '@mc/conditional-rendering'
import { Separator } from '@mc/design-system'
import { FreeTrialPlansHeader, useFreeTrial } from '@mc/free-trial'
import { Trans, useTranslation } from '@mc/i18n'
import { Header, HeaderContent } from '@mc/plans-ui'
import { useStaticData } from '@mc/static-data-react'
import { useMCProExperiment } from '../../experiments/prcng-1194_v1_mc_pro_tier'
import { CHECKOUT_I18N_NAMESPACE } from '../../i18n'
import { GiftHeader } from './components/GiftHeader'

/**
 * This is the header of the plans selection page which contains the main title page
 */
export const PlansHeader = () => {
  const { t } = useTranslation(CHECKOUT_I18N_NAMESPACE)
  const { isGift } = useStaticData<{
    isGift: boolean
  }>()
  const { trial } = useFreeTrial({ isGift })

  const { isVariant2: isMCProVariant2, variant2Layout } = useMCProExperiment()
  // The current variant_2 matrix shows the headline itself from lg up.
  const isHeadlineInMatrix = isMCProVariant2 && variant2Layout === 'current'

  return (
    <Conditional>
      <ShowIf condition={trial.eligible}>
        <FreeTrialPlansHeader />
      </ShowIf>
      <ShowIf condition={isGift}>
        <GiftHeader />
      </ShowIf>

      <ShowIf isDefault>
        <div className={isHeadlineInMatrix ? 'd-lg-none' : undefined}>
          <Header>
            <HeaderContent.MainTitle
              title={t('plans.title')}
              subtitle={
                <Trans
                  i18nKey='plans.subtitleShort'
                  ns={CHECKOUT_I18N_NAMESPACE}
                >
                  <span className='mc-text--bold' />
                </Trans>
              }
            />
          </Header>
          {!isHeadlineInMatrix && (
            <div className='mc-px-4' data-testid='plans-separator'>
              <Separator className='mc-mb-9 mc-mt-5' />
            </div>
          )}
        </div>
      </ShowIf>
    </Conditional>
  )
}
